import React from 'react'

function Contact() {
  return (
    <footer id="section3">
        <div className="cont2 contactP1">
            <div className="start">
                <div className="conthead">
                    Contact US
                </div>
                <div className="number">
                    <div className="address">
                        <p>
                            <i className="fa fa-map-marker" ></i><a href="https://maps.google.com/?q=Rk designs, Ugala"> Village Ugala,Amabala cantt.</a>
                        </p>
                    </div>
                    <div className="mobile">
                        <p>
                            <i className="fa fa-phone" ></i><a href="tel:+91-7015245422">7015245422</a>
                        </p>
                    </div>
                    <div className="emailId">
                        <p>
                            <a href="mailto:rkdesigns70@gmail.com"><i className="fa fa-envelope"></i>rkdesigns70@gmail.com</a>
                        </p>
                    </div>
                    <div className="instagram">
                        <p>
                            <a href="https://instagram.com/rkdesigns70"><i className="fa fa-instagram"></i>Instagram</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div className="Aman" style={{background: "#2e3c50"}}>
            Made by
            <a href="https://amankumar21.netlify.app/"> Aman Kumar</a>
        </div>
    </footer>
  )
}

export default Contact
